import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AnimatedCheck } from '../ui/AnimatedCheck';
import { Button } from '../ui/Button';
export function TaskSuccess({
  title,
  body
}: {
  title: string;
  body: string;
}) {
  const navigate = useNavigate();
  return <main className="mx-auto flex min-h-[70vh] max-w-md flex-col items-center justify-center px-6 text-center" aria-live="polite" data-id="element-659" data-mp="zfe456to9ycj">
      <AnimatedCheck size={64} data-id="element-660" data-mp="14dz7hf480y57" />
      <motion.h1 initial={{
      opacity: 0,
      y: 6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.25,
      duration: 0.25
    }} className="mt-7 text-2xl font-semibold tracking-tight text-ink-900" data-id="element-661" data-mp="19dbrls3pjr43">
        {title}
      </motion.h1>
      <motion.p initial={{
      opacity: 0,
      y: 6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3,
      duration: 0.25
    }} className="mt-2 text-ink-500" data-id="element-662" data-mp="1ie9yqj9g0eqw">
        {body}
      </motion.p>
      <Button className="mt-8" onClick={() => navigate('/loan')} data-id="element-663" data-mp="3k53mvuxhy4ai">
        Back to overview
      </Button>
    </main>;
}